import { dispatch } from 'rfx-core';

import { getChildLogger } from '#/shared/utils/client.logger';

import Form from './_.extend';

const log = getChildLogger('forms.user');

class UserForm extends Form {
  hooks = () => ({
    onSuccess(form) {
      let message;
      return dispatch('auth.register', form.values())
        .then((res) => {
          log.debug('Registration Result: ', res);
          message = `${res.message || 'Registration Successful'}! Please Login`;
        })
        .then(() => dispatch('ui.auth.toggleSection', 'signin'))
        .then(() => dispatch('ui.snackBar.open', message))
        .then(() => form.clear())
        .catch((err) => {
          form.invalidate(err.message);
          dispatch('ui.snackBar.open', err.message);
        });
    },
  });

  setup() {
    return {
      fields: ['email', 'password', 'passwordConfirm'],
      labels: {
        email: 'Email',
        password: 'Password',
        passwordConfirm: 'Confirm Password',
      },
      placeholders: {
        email: 'Insert Email',
        password: 'Insert Password',
        passwordConfirm: 'Insert Confirmation Password',
      },
      rules: {
        email: 'required|email|string|between:5,50',
        password: 'required|string|between:5,40',
        passwordConfirm: 'required|string|between:5,40|same:password',
      },
    };
  }
}

export { UserForm };
